import templateUrl from './character-count.html';

export const characterCountComponent = {
	bindings:{
        maxCount: '@',
        input: '<'
	},

	templateUrl,
	
	controller: class CharacterCountComponent {
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/character-count/character-count.component.js